<template>
  <section class="container content-padding">
    <div class="row">
      <div class="col-12">
        <h3>{{$t('message.menu.notifications')}}</h3>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="text-center w-100 mb-4" v-if="isFetching">
        <i class="far fa-circle-notch fa-spin fa-3x"></i>
      </div>
      <div class="col-12">
        <router-link :to="{name: 'My Reservation', params: {id: item.notification_data.order_id} }"
                     v-for="(item, index) in notifications" :key="index">
          <div class="media">
            <img :src="item.notification_data.professional_picture"
                 width="75" class="align-self-center mr-3 rounded-circle img-fluid" alt="...">
            <div class="media-body ml-2 align-self-center">
              <p
                class="has-read"
                :style="!item.is_read ? {'color':'#000'} : {'color':'#484848'}">
                {{ item.notification_data.professional_name | firstName }}
                {{ item.activity_type_name }}
                <span v-if="item.notification_data.order_code">
                  #{{ item.notification_data.order_code }}
                </span>
                <span v-else-if="item.notification_data.order_id">
                  #{{ item.notification_data.order_id }}
                </span>
              </p>
              <p style="color:#03BBD3;font-weight: 500;" class="m-0">{{convertTimespan(item.time)}}</p>
            </div>
          </div>
          <hr>
        </router-link>

        <button class="btn btn-success w-100" v-if="!isError" :disabled="isFetching"
                @click="loadMore">{{$t('message.button.load_more')}}
        </button>
      </div>
    </div>

  </section>
</template>

<script>
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'Index',
    data () {
      return {
        queryData: {
          page: 0,
          limit: 10
        }
      }
    },
    watch: {
      currentLanguage (newVal) {
        this.$store.commit('user/SET_NOTIFICATIONS', [])
        this.$store.dispatch('user/LOAD_NOTIFICATION_ACTIVITY', this.queryData)
      }
    },
    computed: {
      ...mapState({
        notifications: state => state.user.notifications,
        isError: state => state.user.isError,
        isFetching: state => state.user.isFetching,
        currentLanguage: state => state.globalVal.currentLanguage
      })
    },
    methods: {
      loadMore () {
        this.queryData.page++
        this.$store.dispatch('user/LOAD_NOTIFICATION_ACTIVITY', this.queryData)
      },
      convertTimespan (time) {
        return moment(time).fromNow()
      }
    },
    created () {
      this.$store.commit('user/SET_NOTIFICATIONS', [])
      this.$store.dispatch('user/LOAD_NOTIFICATION_ACTIVITY', this.queryData)
    }
  }
</script>

<style scoped lang="scss">
  .has-read {
    font-weight: normal;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/notifications/Index.vue